export default __webpack_public_path__ + "static/media/SemanaNordica_Agenda_Lunes_eng_scroll.1db7aa8e.png";